import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import { getDeviationNotificationQueue } from '../../../../DeviationPage/redux/helpers';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { getRecipientForDeviation } from '../../../utils';
import CoreBadgeList from '../../CoreBadgeList';
const DeviationCoreBadgeList = ({ deviation , className  })=>{
    var _deviation_extended;
    /*#__PURE__*/ return React.createElement(CoreBadgeList, {
        className: className,
        badges: ((_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : _deviation_extended.awardedBadges) || [],
        recipient: getRecipientForDeviation(deviation),
        notificationQueueName: getDeviationNotificationQueue(deviation),
        biData: BiData({
            evid: 323,
            sectionname: 'deviation',
            typeid: getDeviationResourceType(deviation),
            itemid: deviation.deviationId
        })
    });
};
DeviationCoreBadgeList.displayName = 'DeviationCoreBadgeList';
export default DeviationCoreBadgeList;
